import { prop } from 'js/utils/ramda.util';
import React from 'react';
import { useUserSelector } from 'js/store/hooks';
import { componentService } from 'js/services/component.service';

import style from './ClientIp.scss';

export const ClientIp = () => {
    const value = useUserSelector(prop('clientIp'));

    return <span className={style.property}>{value}</span>;
};

componentService.registerWebContentComponents({ ClientIp });
